/* eslint-disable
    func-names,
    max-len,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const ClientOverviewFormCtrl = function (
  $state,
  $scope,
  blConfirmService,
  User,
  Ledger,
  AddOn,
  CurrencyCollection,
  LedgerCategoryCollection,
  LedgerCollection,
  AddOnCollection,
  NotificationsService,
) {
  this.currencies = new CurrencyCollection();
  this.ledgerCategories = new LedgerCategoryCollection();
  this.ledgers = new LedgerCollection(User.getClientId());
  this.addOns = new AddOnCollection(User.getClientId());
  this.isLedgerAssociated = true;

  this.maxCharacters = 1000;
  this.characterCountDanger = 100;
  let charactersLeft = this.maxCharacters;
  this.getCharactersLeft = () => charactersLeft;

  // set the role field to be a boolean based on whether or not is a functional ledger
  this.roleToBoolean = function (data) {
    if ((data != null ? data.role : undefined) != null) {
      const dataCopy = angular.copy(data);
      dataCopy.role = dataCopy.role != null;

      return dataCopy;
    }

    return data;
  };

  this.clearForm = () =>
    (this.inputVM = {
      currencyId: '2',
      categoryId: '1',
      clientId: User.getClientId(),
      role: false,
    });

  this.input = this.ledger || this.addOn;
  this.inputVM =
    this.roleToBoolean(this.input != null ? this.input.$viewModel() : undefined) ||
    this.clearForm();

  this.save = () => {
    const collection = this.isLedgerAssociated ? this.ledgers : this.addOns;

    const addToCollection = data => collection.$add(data);

    if (this.input != null) {
      return NotificationsService.loader({
        resolve: this.input.$put(this.inputVM.$data()),
        loadingText: 'Updating...',
        successText: 'Saved.',
        failureText: 'Could not be updated. Do you have all required info?',
        useServerFailMessage: true,
      }).then(res =>
        // TODO: don't do a complete refresh to update the view
        collection.$fetch(),
      );
    } // post new object to ledger/add-on
    const newModel = this.isLedgerAssociated ? Ledger : AddOn;

    return NotificationsService.loader({
      resolve: newModel.prototype.$post(this.inputVM),
      loadingText: 'Creating...',
      successText: 'Saved.',
      failureText: 'Could not be created. Do you have all required info?',
      useServerFailMessage: true,
    }).then(data => {
      addToCollection(data);
      return this.clearForm();
    });
  };

  this.delete = () => {
    if (this.input != null) {
      return NotificationsService.loader({
        resolve: this.input.$delete(),
        loadingText: 'Deleting...',
        successText: 'Deleted.',
        failureText: 'Could not be deleted.',
        useServerFailMessage: true,
      }).then(() => $state.go('bench.details.overview'));
    }
  };

  this.updateCharactersLeft = function () {
    if (this.inputVM.details != null) {
      return (charactersLeft = this.maxCharacters - this.inputVM.details.length);
    }
  };

  $scope.$watch('vm.inputVM.details', details => this.updateCharactersLeft());

  this.showFunctionalLedgerCheckbox = function () {
    return (
      this.ledgerCategories.isPotentialFunctionalLedger(this.inputVM.categoryId) &&
      this.inputVM.accountType !== 'STANDARD'
    );
  };
};

module.exports = ClientOverviewFormCtrl;
